import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://modelpark.app';
const DEFAULT_OG_IMAGE = `${BASE_URL}/og-image.png`;

export function Seo({ title, description, name, keywords, imageUrl = DEFAULT_OG_IMAGE }: SeoProps) {
    const canonicalUrl = BASE_URL + window.location.pathname;

    return (
        <Helmet>
            <title>{title}</title>
            <meta
                name="description"
                content={description}
            />
            <meta
                name="author"
                content={name}
            />
            <meta
                name="keywords"
                content={keywords}
            />
            <link
                rel="canonical"
                href={canonicalUrl}
            />

            <meta
                property="og:title"
                content={title}
            />
            <meta
                property="og:description"
                content={description}
            />
            <meta
                property="og:url"
                content={canonicalUrl}
            />
            <meta
                property="og:type"
                content="website"
            />
            <meta
                property="og:image"
                content={imageUrl}
            />
            <meta
                property="og:site_name"
                content="ModelPark"
            />

            <meta
                name="twitter:card"
                content="summary_large_image"
            />
            <meta
                name="twitter:creator"
                content={name}
            />
            <meta
                name="twitter:title"
                content={title}
            />
            <meta
                name="twitter:description"
                content={description}
            />
            <meta
                name="twitter:image"
                content={imageUrl}
            />

            <meta
                name="robots"
                content="index,follow"
            />
        </Helmet>
    );
}

interface SeoProps {
    title: string;
    description: string;
    name: string;
    keywords?: string;
    imageUrl?: string;
}
